import React, { useContext, useEffect } from 'react'
import { store } from '../../stores/graphics_menu'
import LoadingIndicator from '../shared/LoadingIndicator'
import GraphicNext from '../GraphicNext'
import Pagination from '../shared/Pagination'

export default function Select() {
  const { loading, graphics, dispatch, actions, selectedGraphics, uploadMenuState, page, filter, totalPages } = useContext(store)

  useEffect(() => {
    if (graphics == null) {
      dispatch({ type: actions.LOAD_GRAPHICS})
    }
  }, [graphics])

  const handleClick = (graphic) => {
    dispatch({ type: actions.SELECT_GRAPHIC, payload: graphic })
  }

  useEffect(() => {
    dispatch({ type: actions.LOAD_GRAPHICS })
    const menu = document.querySelector('.uploads-menu-scroller')

    if (menu) {
      menu.scrollTop = 0
    }
  }, [page, filter])

  const handlePagination = (page) => {
    dispatch({
      type: actions.PAGINATE,
      page: page,
    })
  }

  return (
    <div className="position-relative min-height-200">
      <LoadingIndicator loading={loading}>
        {graphics && graphics.length > 0 ? (
          <div className="graphic-container">
            {graphics && graphics.map(graphic => {
              const isSelected = selectedGraphics.map(graphic => graphic.id.toString()).includes(graphic?.id.toString())
              return (
                <GraphicNext
                  graphic={graphic}
                  key={`graphic:${graphic.id}`}
                  selected={isSelected}
                  multi={uploadMenuState?.multi}
                  onClick={() => handleClick(graphic)} />
              )
            })}
          </div>
        ) : (
          <div className="card card-empty mb-4">
            <div className="card-body">
              {filter == '' ? `No graphics have been created yet.` : `No graphics match your filter.`}
            </div>
          </div>
        )}
        <Pagination currentPage={page} pageCount={totalPages} onPageChange={handlePagination} />
      </LoadingIndicator>
    </div>
  )
}
